__turbopack_context__.v({
  "backgroundVideo": "bento-square-counter-module-scss-module__z52TQG__backgroundVideo",
  "boxOne": "bento-square-counter-module-scss-module__z52TQG__boxOne",
  "boxOneContent": "bento-square-counter-module-scss-module__z52TQG__boxOneContent",
  "boxOneCopy": "bento-square-counter-module-scss-module__z52TQG__boxOneCopy",
  "heading": "bento-square-counter-module-scss-module__z52TQG__heading",
  "headinggradient": "bento-square-counter-module-scss-module__z52TQG__headinggradient",
  "number": "bento-square-counter-module-scss-module__z52TQG__number",
  "smallerVersion": "bento-square-counter-module-scss-module__z52TQG__smallerVersion",
  "subtitle": "bento-square-counter-module-scss-module__z52TQG__subtitle",
  "vertical": "bento-square-counter-module-scss-module__z52TQG__vertical",
  "videoContainer": "bento-square-counter-module-scss-module__z52TQG__videoContainer",
});
